import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  private scripts: any = {};

  constructor(@Inject(APP_CONFIG) protected appConfig: EnvironmentModel) {
    this.scripts = appConfig.scripts;
  }

  loadScript(name: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.scripts[name].loaded) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = this.scripts[name].src;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.scripts[name].loaded = true;
        resolve();
      };

      script.onerror = (error) => reject(error);

      document.head.appendChild(script);
    });
  }

  loadCookieConsent(): void {
    const cookieScript = this.scripts?.cookieConsent;

    if (!cookieScript || cookieScript.loaded) {
      return;
    }

    const domainScriptId = cookieScript.data?.domainScriptId;

    if (!domainScriptId) {
      console.warn('Domain Script ID is missing for Cookie Consent.');
      return;
    }

    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.src = cookieScript.src;
    scriptElement.async = true;
    scriptElement.setAttribute('data-domain-script', domainScriptId);

    scriptElement.onload = () => {
      cookieScript.loaded = true;
    };

    scriptElement.onerror = (err) => {
      console.error('Cookie Consent script failed to load.', err);
    };

    document.head.appendChild(scriptElement);

    (window as any).OptanonWrapper = () => {
      const w = window as any;
      if (!w.OneTrust || typeof w.OneTrust.OnConsentChanged !== 'function') {
        return;
      }
      let firstFire = true;
      w.OneTrust.OnConsentChanged(() => {
        if (firstFire) {
          firstFire = false;
          return;
        }
        window.location.reload();
      });
    };
  }

  loadPixelMetaScript(): void {
    const pixelScript = this.scripts?.metaPixel;

    if (!pixelScript) {
      return;
    }

    const { src, data } = pixelScript;
    const pixelId = data?.id;

    if (!pixelId) {
      return;
    }

    const inlineScript = document.createElement('script');
    inlineScript.type = 'text/javascript';
    inlineScript.text = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    '${src}');
    fbq('init', '${pixelId}');
    fbq('track', 'PageView');
    `;
    document.head.appendChild(inlineScript);

    const noscriptElement = document.createElement('noscript');
    const trackingImg = document.createElement('img');
    trackingImg.height = 1;
    trackingImg.width = 1;
    trackingImg.style.display = 'none';
    trackingImg.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscriptElement.appendChild(trackingImg);
    document.body.appendChild(noscriptElement);
  }
}
